/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sour_Ok_Clownfish_FadeInputs */

const fr_sour_ok_clownfish_fade = /** @type {(inputs: Sour_Ok_Clownfish_FadeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tous`)
};

/**

* @param {Sour_Ok_Clownfish_FadeInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const sour_ok_clownfish_fade = /** @type {((inputs?: Sour_Ok_Clownfish_FadeInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sour_Ok_Clownfish_FadeInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_sour_ok_clownfish_fade(inputs)
});